/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Section_PaymentInputs */

const vi_tea_purchase_section_payment = /** @type {(inputs: Tea_Purchase_Section_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin thanh toán`)
};

/**

* @param {Tea_Purchase_Section_PaymentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_section_payment = /** @type {((inputs?: Tea_Purchase_Section_PaymentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Section_PaymentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_section_payment(inputs)
});